<template>
  <div class="content">
    <p>为了更好地规范和推广使用富氧空气（93%氧），国家食品药品监督管理总局推出YY 1468-2016《用于医用气体管道系统的氧气浓缩器供气系统》 ，该标准于2016年1月26日发布，2018年1月1日实施。新标准的推行，将“YY/T”变为“YY”，升级成为强制性标准！明确表示浓缩器可以进行管道供应，并指出：</p>
    <p>（1）氧气浓缩器（如：分子筛制氧系统）制取的氧气（富氧空气，93%氧）可以用于医用气体管道系统；</p>
    <p>（2）氧气浓缩器能用于向医用气体管道系统输送作为医用氧气（如：中国药典中的“氧”）替代品的富氧空气（93%氧）；</p>
    <p>（3）氧气浓缩器可与含有100%医用氧气的供气源（即氧气瓶或低温容器）组合使用；</p>
    <p>（4）用氧方式的使用选择权在于医疗卫生机构自身；</p>
    <p>（5）带有氧气浓缩器的供气系统能在管道分配系统安装时进行安装或作为已有供气系统的替代或附加。</p>
    <p>新标准通篇说明应适当将氧气浓缩器供气系统引入到卫生保健机构。未来，基层医疗卫生机构需要改善用氧方式，可以通过引入“氧气浓缩器”来提升用气品质和医疗质量。</p>
    <p>标准中已明确了氧气浓缩器制取的氧气可以用于在医疗机构中的医用气体管道系统，并没有适用范围的限定。</p>
    <div class="imgbox">
      <img src="../../assets/images/airsep/criterionimg1.png" alt="">
      <img src="../../assets/images/airsep/criterionimg2.png" alt="">
      <img src="../../assets/images/airsep/criterionimg3.png" alt="">
      <img src="../../assets/images/airsep/criterionimg4.png" alt="">
      <img src="../../assets/images/airsep/criterionimg5.png" alt="">
      <img src="../../assets/images/airsep/criterionimg6.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabOxygenConcentrator'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    line-height: 36px;
    text-indent: 40px;
  }
  .imgbox{
    margin: 20px 0px;
    img{
      margin-top: 10px;
      border: 1px solid #fff;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }
  }
}
</style>
